import { Checkbox } from "../core/form/Checkbox";
import { Dropdown } from "../core/form/Dropdown";
import { Radio } from "../core/form/Radio";
import { DataContext, useDataContext } from "../core/hooks/useData";
import { Field, FieldOptions } from "../core/pdf/types";
import { JSEditor } from "../core/ui/JSEditor";
import { Modal } from "../core/ui/Modal";
import { formatDateCustom } from "../formatters/format";

const cols = {
	"number": {
		bg: "#f68e56",
		fg: "#000",
	},
	"currency": {
		bg: "#acd373",
		fg: "#000",
	},
	"address": {
		bg: "#00bff3",
		fg: "#000",
	},
	"pob": {
		bg: "#7accc8",
		fg: "#000",
	},
	"name": {
		bg: "#8560a8",
		fg: "#fff"
	},
	"date": {
		bg: "#f06eaa",
		fg: "#fff"
	},
	"acn": {
		bg: "#f06633",
		fg: "#fff"
	}
} as any;

const formats = [
	{
		id: "number/include-words",
		type: "number",
		text: "Fifty (50)"
	},
	{
		id: "currency",
		type: "currency",
		text: "$50.00"
	},
	{
		id: "currency/include-words",
		type: "currency",
		text: "Fifty dollars ($50.00)"
	},
	{
		id: "date",
		type: "date",
		text: formatDateCustom(new Date(), "date"),
	},
	{
		id: "date/short",
		type: "date",
		text: formatDateCustom(new Date(), "date/short"),
	},
	{
		id: "address",
		type: "address",
		text: "123 Collins Street, Melbourne"
	},
	{
		id: "address/smsf",
		type: "address",
		text: "123 Collins Street, Melbourne in the State of Victoria"
	},
	{
		id: "address/smsf/careOf",
		type: "address",
		text: "C/-, 123 Collins Street, Melbourne in the State of Victoria"
	},
	{
		id: "address/full",
		type: "address",
		text: <span>123 Collins Street<br/>MELBOURNE VIC 3000</span>
	},
	{
		id: "address/full/careOf",
		type: "address",
		text: <span>C/-<br/>123 Collins Street<br/>MELBOURNE VIC 3000</span>
	},
	{
		id: "address/lines",
		type: "address",
		text: <span>
				Unit 1<br/>
				123 Collins Street<br/>
				MELBOURNE<br/>
				VIC<br/>
				3000
			</span>
	},
	{
		id: "address/state",
		type: "address",
		text: <span>Victoria</span>
	},
	{
		id: "address/lines+careOf",
		type: "address",
		text: <span>
				C/-<br/>
				Unit 1<br/>
				123 Collins Street<br/>
				MELBOURNE<br/>
				VIC<br/>
				3000
			</span>
	},
	{
		id: "pob",
		type: "pob",
		text: "Melbourne, VIC"
	},
	{
		id: "name",
		type: "name",
		text: "John Doe"
	},
	{
		id: "name/full",
		type: "name",
		text: "Mr John James Doe"
	},
	{
		id: "name/full/no-title",
		type: "name",
		text: "John James Doe"
	},
	{
		id: "name/full/split-family",
		type: "name",
		text: <span>
				Doe<br/>
				John James
			</span>
	},
	{
		id: "name/first-abbrev",
		type: "name",
		text: "Mr J Doe"
	},
	{
		id: "name/family",
		type: "name",
		text: "Doe"
	},
	{
		id: "name/given",
		type: "name",
		text: "John James"
	},
	{
		id: "acn",
		type: "acn",
		text: "123 456 789"
	},

];

const caseOptions = [
	{
		id: undefined,
		text: "Unchanged"
	},
	{
		id: "sentence",
		text: "Sentence case"
	},
	{
		id: "title",
		text: "Title Case"
	},
	{
		id: "lower",
		text: "lower"
	},
	{
		id: "upper",
		text: "UPPER"
	},
]

export function FieldEditor(props: {
	fieldOptions: FieldOptions,
	field: Element,

	onClose: () => void,
}) {

	const dataContext = useDataContext({
		initialValue: {...props.fieldOptions},
	})

	return (
		<Modal
			size="width-50vw"
			title="Edit Field"

			saveOnEnterKey={false}

			onCancel={() => {
				props.onClose();
			}}
			onSave={() => {
				const val = encodeURIComponent(JSON.stringify(dataContext.value));
				props.field.setAttribute("data-options", val);
				props.onClose();
			}}
		>
			<DataContext.Provider value={dataContext}>

				<div className="flex vert align-start gap-10">

					<div className="width-100pc" style={{border:"solid #ddd 1px"}}>
						<JSEditor prop="script" />
					</div>

					<Dropdown
						prop="format"
						title="Format"
						blankOption={{
							value: "",
						}}
						items={formats}
						getValue={(item) => {
							return item.id;
						}}
						getDisplay={(item: any) => {
							const col = cols[item.type];

							return (
								<div className="horiz align-center" style={{display: "flex"}}>
									<span className="tag" style={{backgroundColor: col.bg, color: col.fg, width: "100px"}}>
										{item.type}
									</span>
									<span style={{marginLeft:"5px"}}>
										{item.text}
									</span>
								</div>
							)
						}}
					/>

					<Checkbox 
						prop="bold"
						title="Bold"
					/>

					<Radio
						prop="forceCase"
						options={caseOptions}
						getValue={(item) => {
							return item.id as any;
						}}
						getDisplay={(item: any) => {
							return item.text;
						}}
					/>


				</div>
			</DataContext.Provider>
		</Modal>
	)
}